const LOCATION_COOKIE_KEY = 'location';
const LOCATION_CHANGE_EVENT_KEY = 'shipping.voltran.shippingLocation.location.change';
const DELIVERY = {
  NEXT_DAY_DELIVERY: 'VariantList.VariantListing.JetDeliveryCities.Code',
  EXPRESS_DELIVERY: 'VariantList.VariantListing.ExpressDeliveryWarehouses.Code',
  PRIME_KEY: 'VariantList.VariantListing.TagList.jet€20teslimat€20prime',
  PRIME_VALUE: 'Jet€20Teslimat€20Prime',
};
const NEXT_DAY_DELIVERY_URL_REGEX = new RegExp(`(${DELIVERY.NEXT_DAY_DELIVERY}:?[0-99]?.?;?)`);
const EXPRESS_DELIVERY_URL_REGEX = new RegExp(`(${DELIVERY.EXPRESS_DELIVERY}:?[0-99999]?.?.?.?.?;?)`);
const JET_DELIVERY_TAG_NAME = 'efsane-teslimat-hb-taglabel';
const JET_DELIVERY_TAG_LIST_NAME = 'Yarın Kapında';

export {
  LOCATION_COOKIE_KEY,
  LOCATION_CHANGE_EVENT_KEY,
  DELIVERY,
  NEXT_DAY_DELIVERY_URL_REGEX,
  EXPRESS_DELIVERY_URL_REGEX,
  JET_DELIVERY_TAG_NAME,
  JET_DELIVERY_TAG_LIST_NAME,
};
